import { useCallback, useEffect, useState } from "react";
import OrderCard from "../../../../components/common/orderCard";
import { Pagination } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrdersList } from "../../../../store/slices/orderSlice";

const OrderHistory = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const dispatch = useDispatch();
  const orders = useSelector((state) => state?.order);
  const text = useSelector((state) => state?.text?.value);
  const orderValues = orders?.response;
  const fetchData = useCallback(async () => {
    const payload = {
      orderStatus: ["COMPLETED"],
      itemPerPage: 6,
      currentPage: currentPage,
      text: text || null,
    };
    dispatch(fetchOrdersList(payload));
  }, [currentPage, dispatch, text]);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    fetchData();
  }, [currentPage, fetchData]);

  if (!orderValues?.totalItems) {
    return (
      <div className="flex justify-center opacity-50 mt-20">
        <h1 className="text-xl mr-2 mt-0.4">No Orders Yet</h1>
      </div>
    );
  }
  return (
    <div>
      <div className="grid  md:grid-cols-2 2xl:grid-cols-3  gap-2">
        {orderValues?.items?.map((data, i) => (
          <OrderCard key={i} data={data} />
        ))}
      </div>
      <div className="flex justify-center items-center pagination-container my-2">
        <Pagination
          current={currentPage}
          total={orderValues?.totalItems}
          pageSize={4}
          onChange={(e) => {
            handlePageChange(e);
          }}
        />
      </div>
    </div>
  );
};
export default OrderHistory;
